import { GlTooltipDirective, GlSprintf } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import TimeAgoTooltip from '../../vue_shared/components/time_ago_tooltip.vue?vue3';
import SnippetDescription from './snippet_description_view.vue?vue3';
export default {
    name: 'SnippetTitle',
    components: {
        TimeAgoTooltip,
        GlSprintf,
        SnippetDescription
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        snippet: {
            type: Object,
            required: true
        }
    }
};
